import FJConstant from '../../constants/FJConstant.js';

const FJAIVideoGeneratorData = {
    MENU_LIST: [
        {
            text: 'vocal',
            value: FJConstant.VOCAL,
        },
        {
            text: 'instrumental',
            value: FJConstant.INSTRUMENTAL,
        },
    ],
    PROMPT_TEXT_LIMIT: 2000,
};

export default FJAIVideoGeneratorData;
